import image1 from "../assets/img/blog/blog-1.jpg";
import image2 from "../assets/img/blog/blog-2.jpg";
import image3 from "../assets/img/blog/blog-3.jpg";
import image4 from "../assets/img/blog/blog-4.jpg";
import image5 from "../assets/img/blog/blog-5.jpg";
import image6 from "../assets/img/blog/blog-6.jpg";
import image7 from "../assets/img/blog/blog-7.jpg";
import image8 from "../assets/img/blog/blog-8.png";
import image9 from "../assets/img/blog/blog-9.png";
import image10 from "../assets/img/blog/blog-10.png";
import image11 from "../assets/img/blog/blog-11.jpg";

const blogData = [
    {
        number: '01',
        id: 'construction-project-planning-steps',
        date: '10',
        comment: '2',
        title: 'Construction Project Planning Steps',
        image: image1,
        description: 'A successful construction project starts with proper planning. Site analysis, budget planning, material selection and timeline creation are the key foundations of a smooth execution process.',
        delay: '0.4',
    },
    {
        number: '02',
        id: 'impact-of-weather-on-construction-sites',
        date: '12',
        comment: '3',
        title: 'Impact of Weather on Construction Sites',
        image: image2,
        description: 'Weather conditions such as heavy rain, snow and extreme heat can directly affect construction progress. Proper scheduling and material protection are essential to avoid delays.',
        delay: '0.7',
    },
    {
        number: '03',
        id: 'how-to-choose-right-construction-company',
        date: '13',
        comment: '6',
        title: 'How to Choose the Right Construction Company',
        image: image3,
        description: 'Selecting a reliable construction company is crucial. Experience, portfolio, engineering capability and project management quality should always be evaluated.',
        delay: '1',
    },
    {
        number: '04',
        id: 'common-mistakes-in-renovation-projects',
        date: '15',
        comment: '7',
        title: 'Common Mistakes in Renovation Projects',
        image: image4,
        description: 'Poor planning, incorrect budgeting and unqualified labor are the most common mistakes in renovation projects. Proper supervision prevents costly errors.',
        delay: '0.4',
    },
    {
        number: '05',
        id: 'commercial-building-space-optimization',
        date: '17',
        comment: '5',
        title: 'Commercial Building Space Optimization',
        image: image5,
        description: 'Efficient use of space in commercial buildings improves functionality. Modular design, open layouts and smart partitioning increase productivity.',
        delay: '0.7',
    },
    {
        number: '06',
        id: 'future-of-smart-construction-technology',
        date: '21',
        comment: '3',
        title: 'Future of Smart Construction Technology',
        image: image6,
        description: 'Modern construction integrates smart technologies such as IoT systems, automated machinery and energy-efficient building solutions.',
        delay: '1',
    },
    {
        number: '07',
        id: 'industrial-factory-construction-guide',
        date: '22',
        comment: '4',
        title: 'Industrial Factory Construction Guide',
        image: image7,
        description: 'Industrial facilities require strong structural planning, heavy-load engineering and safety compliance for long-term durability and efficiency.',
        delay: '0.5',
    },
    {
        number: '08',
        id: 'office-building-design-standards',
        date: '23',
        comment: '2',
        title: 'Office Building Design Standards',
        image: image8,
        description: 'Modern office buildings focus on employee comfort, energy efficiency and flexible working environments with optimized architectural design.',
        delay: '0.6',
    },
    {
        number: '09',
        id: 'residential-construction-trends',
        date: '24',
        comment: '3',
        title: 'Residential Construction Trends',
        image: image9,
        description: 'Residential construction is evolving with sustainable materials, earthquake-resistant structures and modern minimalist designs.',
        delay: '0.8',
    },
    {
        number: '10',
        id: 'infrastructure-project-management',
        date: '25',
        comment: '5',
        title: 'Infrastructure Project Management',
        image: image10,
        description: 'Infrastructure projects require strict coordination, resource management and engineering precision for roads, bridges and utilities.',
        delay: '0.9',
    },
    {
        number: '11',
        id: 'sustainable-building-practices',
        date: '26',
        comment: '4',
        title: 'Sustainable Building Practices',
        image: image11,
        description: 'Sustainable construction focuses on eco-friendly materials, energy efficiency and reducing environmental impact in modern architecture.',
        delay: '1',
    },
];

export default blogData;